module.exports = __webpack_public_path__ + "img/question-solid.ead9d02d.svg";